<template>
  <div class="wrap">
    <div class="topWrap"></div>
    <div class="centerWrap">
          <div class="d-flex">
            <div class="vote-tag-title titleWrap">数字化学习未来实验室</div>
          </div>
          <div class="vote-body px-5 pt-6">学习力调查</div>
          <div class="vote-en-body px-5 pt-1">Learning Power Research</div>
          <div>
          
            <div style="width:333px; margin:0 auto ;">
              <p class="clickText">请点击未被封闭的区域进行评测指标重要性的排列:</p>
                <table cellspacing="0" class="tableWrap">
                <thead>
                  <tr>
                    <th class="noMax"></th>
                    <th v-for="(item,index1) in list" :key="item.key" >{{ item.name }}</th>
                  </tr>
                </thead>
                <tr v-for="(item,inx) in list" :key="item.key">
                  <td>{{ item.name }}</td>
                  <td v-for="(child,index) in list" :key="`${child.key}_${item.key}`" style="cursor:pointer;" :class="imgStyle(inx,index)" @click="clickTd($event,child,inx,index)"></td>
                </tr>
              </table>

              <p class="resultText">{{xOne}}与{{yTwo}}重要性的比较结果是:</p>
              <v-slider
                class="mt-2"
                v-model="bpm"
                color="#a02116"
                track-color="grey"
                height="10px"
                min="0"
                max="9"
                :step="1"
    
                style="width:340px;height:40px;"
                show-ticks="always"
              >
                <template v-slot:prepend>
                  <div style="width: 30px; text-align:center;color:#478845;">0</div>
                </template>

                <template v-slot:append>
                  <div style="width:30px;text-align:center;color:#478845;">9</div>
                </template>
              </v-slider>
              <div class="sliderText">
                <div style="width: 80px; text-align:center; font-size: 13px;">同等重要</div>
                <div style="width: 80px;text-align:center;font-size: 13px;">非常重要</div>
              </div>
              
      
            </div>
          </div>
          <div class="d-flex flex-column justify-center align-center">
            <!-- <v-btn class="mt-6" color="success">提交结果</v-btn> -->
            <v-btn
          class="ma-2"
          outlined
          rounded
          color="success"
        >
        提交结果
        </v-btn>
          </div>
          <div class="footerText">
             <P><span>元学</span></P>
          </div>
    </div>
    <div class="bottomWrap"></div>
  </div>
</template>

<script>

import { queryEvaluation } from '../../../api/Indicatorevaluation.js';

export default {
  data() {
    return {
      tableDat:[

      ],
      xOne:'',
      yTwo:'',
      list: [
        { key: 'acknowledge', name: '认知领域' },
        { key: 'practice', name: '实践领域' },
        { key: 'feeling', name: '情感领域' },
      ],
      bpm: 0,
    };
  },
  created() {},
  methods: {
    imgStyle(row,column){
      if(row==0&&column==0){
          return 'noMax'
      }else if(row==1&&column==1){
        return 'noMax'
      }else if(row==2&&column==2){
        return 'noMax'
      }

    },
    itemImg(){
        return require('@/assets/img/nobg.png')
    },
    clickTd(e,data,inx,index){
      e.target.classList.toggle('noSend');
       var index1 = this.list.findIndex(function(item){
         return item.key==data.key
       })
       this.xOne  = this.list[inx].name;
       this.yTwo = data.name;
 
   
    }
  },
};
</script>
<style>
.vote-tag-title {
  background-color: #478845;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.2em;
}

.vote-body {
  color: #478845;
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 0.1em;
}

.vote-en-body {
  color: #478845;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1em;
}

table,
th,
td {
  font-weight: 400;
  border: #cccccc 1px solid;
}

tr,
td:first-child {
  color: #7a7885;
}

table {
  margin: 0 auto;
  display: block;
  overflow-x: auto;
  border-spacing: 0;
}

tbody {
  white-space: nowrap;
}

th,
td {
  padding: 10px 20px;
  border-top-width: 0;
  border-left-width: 0;
}

th {
  color: #7a7885;
  position: sticky;
  top: 0;
  background: #fff;
  vertical-align: bottom;
}

th:last-child,
td:last-child {
  border-right-width: 0;
}

tr:last-child td {
  border-bottom-width: 0;
}

.sliderText{
  width: 340px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   color: #478845;
}

.v-slider__thumb{
  border-radius: 0!important;
  height: 30px;
  background-color: rgba(0,0,0,.26) !important;
}
.v-slider__thumb::before{
  top:-3px !important;
}


.clickText{
  letter-spacing:2px;
  text-indent: 10px;
  width: 100%;
  color: #478845;
  font-size: 12px;
  margin-top: 40px;
  font-weight: 500;
  text-align: left;
}
.resultText{
  letter-spacing:2px;
  text-indent:10px;
  width: 100%;
  color: #478845;
  font-size: 12px;
  margin-top: 40px;
  font-weight: 500;
  margin-left:0 !important;
}
.wrap{
  position: fixed;
  width: 100%;
  height: 100%;
}
.topWrap {
  height: 8%;
  width: 100%;
  border-bottom: 1px dashed gray;
}
.centerWrap{
  position:relative;
  height: 84%;
}
.bottomWrap {
  height: 8%;
  width: 100%;
  border-top: 1px dashed gray;
}

.v-slider--horizontal .v-slider__track-container{
  height: 10px !important;
}
.tableWrap{
  /* font-size: 14px; */
  width: 100%;
}
th{
  font-size: 14px;
  padding: 10px 15.5px;
}
td{
  font-size: 14px;
  padding: 5px 5px;
}
.footerText{
  position: absolute;
  bottom: 0px;
  color: #478845;
  width: 100%;
  /* font-size: 0.8rem; */
  /* font-weight: bold; */
  /* letter-spacing: 0.1em; */
  

}
.footerText p{
  
  margin: 0px;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  text-align: right;
}
.footerText p span{
 display: inline-block;
}
.footerText p span:nth-child(2){
  margin-right: 10px;
}
.noSend{
  background-color:#35692b
}
.yesSend{
  background-color:#a0d062;
}
.noMax{
  background-image: url('../../../assets/img/nobg.png');
  background-repeat: no-repeat;
  background-size: cover;

  pointer-events: none;

  /* :style="{
                      backgroundImage:'url('+itemImg(item)+')',
                      backgroundRepeat:'norepeat',
                      backgroundSize:'100%'
                  }"  */
}
</style>
